import React from 'react';
import sty from './ProdDetailPage.module.css';

const PrdDtlDscr = ({ dtlName, dtlDscr }) => {

  if (!dtlDscr) {
      return null;
  }
  
  return (
    <div draggable className={sty.dtlDscrDiv}>
      <div className={sty.dtlTitle}>{dtlName}</div>
      <div className={sty.dtlDscr}>
        {dtlDscr.split('\n').map((item, index) => (
          <React.Fragment key={index}>
            {item}
            <br />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default PrdDtlDscr;